import { FormControlLabel, Radio } from '@mui/material'

interface RadioSelectProps {
  value: string
  label: string
}
export const RadioSelect: React.FC<RadioSelectProps> = ({ value, label }) => {
  return (
    <FormControlLabel
      sx={{ width: '100%', padding: 1, margin: 0, border: '1px solid lightgray', borderRadius: '4px' }}
      value={value}
      control={<Radio />}
      label={label}
    />
  )
}
